var render, staticRenderFns
import script from "./UploadFilesLg.vue?vue&type=script&lang=js"
export * from "./UploadFilesLg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f13e35",
  null
  
)

export default component.exports